export const requiredField = {
  required: true,
  message: "Обязательное поле",
};
